module.exports = __webpack_public_path__ + "static/img/xiaodu-1.94ca934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiaodu-1.png
// module id = 9jhz
// module chunks = 36